// let chalk = require('chalk')
let splitMessageLines = (msg): Array<string> => {
    let messages = msg.split("\\n");
    if (messages.length === undefined) {
        return [msg]
    }
    return [messages]
}

export enum LogLevel {
    INFO = "info",
    WARN = "warn",
    ERROR = "error",
    DEBUG = "debug",
    CRITICAL = "critical",
}

export class Logger {
    private static enabled = false

    public static setEnabled(enabled: boolean) {
        this.enabled = enabled
    }

    private static error(message: string): void {
        if (!this.enabled) return
        console.error(message);
    }

    private static warn(message: string): void {
        if (!this.enabled) return
        console.warn(message);
    }

    private static info(message: string): void {
        if (!this.enabled) return
        console.info(message);
    }
 
    public static log(message: string, message2: string): void {
        if (!this.enabled) return
        if (message2) {
            message = message + " " + message2;
        }
        console.log(message);
    }

    public static logObject(where: string, object: any, level: LogLevel = LogLevel.INFO) {  
        const message = `[${where}]\n ${JSON.stringify(object, null, 2)}`;
        switch (level) {
            case LogLevel.INFO:
                this.info(message);
                break;
            case LogLevel.WARN:
                this.warn(message);
                break;
            case LogLevel.ERROR:
                this.error(message);
                break;
            case LogLevel.DEBUG:
                this.info(message);
                break;
            case LogLevel.CRITICAL:
                this.logCritical(where, message);
                break;
            default:
                this.info(message);
                break;
        }
    }

    public static logError(where: string, text: string) {
        let fullMessage = "["+where+"] " + text 
        let messages = splitMessageLines(fullMessage)
        for (let message of messages) {
            this.error(message)
        }
    }

    public static logCritical(where: string, text: string) {
        let message = "["+where+"] " + text 
        this.warn(message)
    }

    static censor(censor: any) {
        var i = 0;
        return function(key, value) {
            if(i !== 0 && typeof(censor) === 'object' && typeof(value) === 'object' && censor === value) 
            return '[Circular]'; 
        
            if(i >= 29) // seems to be a harded maximum of 30 serialized objects?
            return '[Unknown]';
        
            ++i; // so we know we aren't using the original object anymore
        
            return value;  
        }
    }
}

process.env.REACT_APP_LOG_ENABLED === "NO" ? Logger.setEnabled(false) : Logger.setEnabled(true)
